export default __webpack_public_path__ + "src/images/packages/unembeza-boutique-lodge/fe215ba9388d46e86d268562531a22a3-2.png";